export function updateDealerIcon(dealer) {
    const facilityTypeNames = [];
    const active_assessments = dealer.assessment_formats_facility_name

    for (const facilityType of active_assessments) {
        let iconName;

        switch (facilityType) {
            case "Diesel":
                iconName = "diesel";
                break;
            case "Body Shop":
                iconName = "body-shop";
                break;
            case "EV Certification":
                iconName = "model-e";
                break;
            case "Quicklane":
                iconName = "quick-lane";
                break;
            default:
                iconName = "";
        }

        if (iconName !== '') {
            facilityTypeNames.push(iconName);
        }

    }

    if (dealer.ford_pro_dealer === true){
      facilityTypeNames.push("elite")
    }
    if (dealer.has_ford_pro === true){
      facilityTypeNames.push("ford-pro")
    }
    return facilityTypeNames;
}

export function divideTwoNums(firstNum, secondNum) {
    let result = Math.round((firstNum / secondNum) *100) / 100 || 0;
    return isFinite(result) ? result : 0;
}

export function debug(...args) {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'qa') {
    console.log("DEBUG", ...args)
  }
}

export function debug_error(...args) {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'qa') {
    console.error("ERROR", ...args)
  }
}
